import React from "react";
import "./Insurance.scss";
function Insurance() {
  return (
    <div>
      <div className="insurance">
        <div className="insurance_heading">Do you take insurance?</div>
        <div className="insurance_para">
          No, we do not take any insurance. Payment can be made by any major
          credit cards through our secure system
        </div>
      </div>
    </div>
  );
}

export default Insurance;
